import { assertPrivateSession, getPrivateSessionState } from "./private-session";

const apiBaseUrl = (
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? ""
).replace(/\/+$/, "");

export function buildRequestUrl(path: string): string {
  const normalizedPath = path.replace(/^\/+/, "");
  const base = apiBaseUrl || `${window.location.origin}/api`;
  return `${base}/${normalizedPath}`;
}

export async function apiFetchClient(
  path: string,
  options: RequestInit = {},
): Promise<Response> {
  const privateRequest = path.replace(/^\/+/, "").startsWith("admin/") &&
    !/^(?:admin\/auth\/(?:login|logout|switch-store))(?:\?|$)/.test(path.replace(/^\/+/, ""));
  const generation = getPrivateSessionState().generation;
  if (privateRequest) assertPrivateSession(generation);
  let response: Response;
  try {
    response = await fetch(buildRequestUrl(path), { ...options, credentials: "include" });
  } catch (error) {
    if (privateRequest) assertPrivateSession(generation);
    throw error;
  }
  if (privateRequest) assertPrivateSession(generation);
  return response;
}

/** Uncached recovery read while ordinary private requests are paused. */
export function fetchSessionAfterBindingFailure(): Promise<Response> {
  return fetch(buildRequestUrl("admin/auth/me?includeFirebaseToken=true"), {
    credentials: "include", cache: "no-store", signal: AbortSignal.timeout(5000),
  });
}
